export const ACCOUNT_INACTIVE = 'ACCOUNT_INACTIVE';
export const UNAUTHORIZED = 'UNAUTHORIZED';
//============================================================================
//============================== Root Admin Role =============================
//============================================================================
export const ROOT_ADMIN_SK = 'Root Admin';

/** Official Yangon region code (regions.code). Used for Product action UI gating. */
export const YANGON_REGION_CODE = 'MMR012';

//============================================================================
//============================== Status =================================
//============================================================================
export const ACTIVE_LK = 'Active';
export const INACTIVE_LK = 'Inactive';

export const PENDING_LK = 'Pending';
export const APPROVED_LK = 'Approved';
export const REJECTED_LK = 'Rejected';

export const PENDING_SK = 'pending';
export const APPROVED_SK = 'approved';
export const REJECTED_SK = 'rejected';

export const PASSED_SK = 'passed';
export const FAILED_SK = 'failed';

export const DRAFT_SK = 'draft';
export const ORDERED_SK = 'ordered';
export const RECEIVED_SK = 'received';

export const CASH_SK = 'cash';
export const CREDIT_SK = 'credit';

export const CONFIRMED_SK = 'confirmed';
export const PREPARED_SK = 'prepared';
export const SHIPPED_SK = 'shipped';
export const CANCELLED_SK = 'cancelled';
export const PARTIAL_SK = 'partial';
export const FULFILLED_SK = 'fulfilled';
export const OUT_OF_STOCK_SK = 'out_of_stock';

export const RAW_MATERIAL_SK = 'raw_material';
export const FINISHED_GOOD_SK = 'finished_good';

export const RAW_MATERIAL_LK = 'Raw Material';
export const FINISHED_GOOD_LK = 'Finished Good';

//============================================================================
//============================== Discrepancy Types ===========================
//============================================================================
/** API/DB value — do not change */
export const DISCREPANCY_SHORTAGE_SK = 'shortage';
/** API/DB value — do not change */
export const DISCREPANCY_OVERAGE_SK = 'overage';
/** API/DB value — do not change */
export const DISCREPANCY_DAMAGED_SK = 'damaged';

/** User-facing display label */
export const DISCREPANCY_SHORTAGE_LK = 'ပစ္စည်းလို';
/** User-facing display label */
export const DISCREPANCY_OVERAGE_LK = 'ပစ္စည်းပို';
/** User-facing display label */
export const DISCREPANCY_DAMAGED_LK = 'Damaged';

